<template>
  <div
    class="form-group"
    :class="
      item.suffix || item.prefix || item.nm
        ? item.groupClass || 'mb-0'
        : item.groupClass || ''
    "
  >
    <!-- <b-modal
      id="modal-create-form"
      v-if="item.createComponent"
      size="lg"
      centered
      hide-footer
    >

      <div class="create-modal-component-loader"> <component :is="componentLoader" isModal @success="onSuccessCreate($event)"></component>
      </div>
    </b-modal> -->
    <ValidationProvider
      mode="eager"
      :name="item.label"
      :rules="item.validation.join('|')"
      v-slot="{ classes, errors }"
      :class="[item.suffix || item.prefix ? 'row' : '', item.rowclass]"
    >
      <label
        v-if="
          item.type != 'hidden' &&
          item.label != null &&
          item.label != '' &&
          !item.hideLabel
        "
        :class="{
          'd-block': dateType.includes(item.type),
          'col-12': item.suffix || item.prefix,
          [item.labelClass ? item.labelClass : '']: true,
        }"
      >
        {{ item.label }}
        <span v-if="item.validation.includes('required')" class="text-danger">
          *
        </span>
      </label>
      <label
        v-if="item.prefix"
        :class="item.classLabel ? item.classLabel : 'col-auto'"
        class="col-form-label"
      >
        {{ item.prefix }}
      </label>
      <base-alert
        v-if="item.alert"
        :text="item.alert"
        :icon="item.alertIcon"
        :variant="item.alertVariant"
      ></base-alert>
      <!-- Input Type Default  -->
      <template v-if="defaultType.includes(item.type)">
        <template v-if="item.useBS">
          <b-input-group
            size="lg"
            :class="{ [item.inputGroupClass]: true }"
            v-if="item.option.prepend || item.option.append"
          >
            <template v-if="item.option.prepend">
              <b-input-group-prepend
                v-for="(p, i) in item.option.prepend"
                :key="'pre-' + i"
              >
                <div class="input-group-text">
                  <i v-if="p.type === 'icon'" :class="p.name + ' p-0'"> </i>
                  <span v-if="p.type === 'text'"> {{ p.name }} </span>
                </div>
              </b-input-group-prepend>
            </template>
            <input
              :disabled="disabled"
              v-bind:value="value"
              v-bind="item.attr"
              v-on:input="$emit('input', $event.target.value)"
              v-on:change="
                $emit('change', errors[0] ? '' : $event.target.value)
              "
              v-on:blur="$emit('blur', $event.target.value)"
              :type="item.type"
              class="form-control"
              :class="[
                item.validation.length > 0 ? classes : '',
                item.suffix || item.prefix ? 'col' : '',
                item.ic,
              ]"
              :placeholder="
                item.placeholder
                  ? item.placeholder
                  : 'Ketikkan ' + (item.label || '') + ' disini...'
              "
            />
            <template v-if="item.option.append">
              <b-input-group-append
                :class="{ [item.inputGroupClass]: true }"
                v-for="(p, i) in item.option.append"
                :key="'app-' + i"
              >
                <div class="input-group-text">
                  <i v-if="p.type === 'icon'" :class="p.name + ' p-0'"> </i>
                  <span v-if="p.type === 'text'"> {{ p.name }} </span>
                </div>
              </b-input-group-append>
            </template>
          </b-input-group>
          <div class="invalid-feedback">{{ errors[0] }}</div>
        </template>
        <template v-else>
          <input
            :disabled="disabled"
            v-bind:value="value"
            v-bind="item.attr"
            v-on:input="$emit('input', $event.target.value)"
            v-on:change="$emit('change', errors[0] ? '' : $event.target.value)"
            v-on:blur="$emit('blur', $event.target.value)"
            :type="item.type"
            class="form-control"
            :class="[
              item.validation.length > 0 ? classes : '',
              item.suffix || item.prefix ? 'col' : '',
              item.ic,
            ]"
            :placeholder="
              item.placeholder
                ? item.placeholder
                : 'Ketikkan ' + (item.label || '') + ' disini...'
            "
          />
        </template>
      </template>

      <!-- Input Type Number  -->
      <template v-else-if="numberType.includes(item.type)">
        <template v-if="item.useBS && item.type === 'money'">
          <b-input-group size="lg" prepend="Rp.">
            <vue-numeric
              :disabled="disabled"
              v-model="tmp_value"
              separator=","
              :empty-value="''"
              :currency="item.type === 'money' ? '' : null"
              v-bind="item.attr"
              v-bind:min="1"
              v-bind:minus="false"
              v-on:input="$emit('input', tmp_value)"
              class="form-control w-auto"
              :class="[
                item.validation.length > 0 ? classes : '',
                item.suffix || item.prefix ? 'col' : '',
                item.ic,
              ]"
              :placeholder="
                item.decimal
                  ? '1.00'
                  : item.placeholder
                  ? item.placeholder
                  : 'Ketikkan ' + (item.label || '') + ' disini...'
              "
            />
          </b-input-group>
        </template>
        <template v-else-if="item.useBS && item.type !== 'money'">
          <b-input-group
            :class="{ [item.inputGroupClass]: true }"
            size="lg"
            v-if="item.option.prepend || item.option.append"
          >
            <template v-if="item.option.prepend">
              <b-input-group-prepend
                :class="{ [item.inputGroupClass]: true }"
                v-for="(p, i) in item.option.prepend"
                :key="'pre-' + i"
              >
                <div class="input-group-text">
                  <i v-if="p.type === 'icon'" :class="p.name + ' p-0'"> </i>
                  <span v-if="p.type === 'text'"> {{ p.name }} </span>
                </div>
              </b-input-group-prepend>
            </template>
            <vue-numeric
              :disabled="disabled"
              v-model="tmp_value"
              separator=","
              :precision="item.decimal ? 2 : 0"
              :empty-value="item.decimal ? 0 : ''"
              :decimal-separator="'.'"
              v-bind="item.attr"
              v-on:input="$emit('input', tmp_value)"
              class="form-control w-auto"
              :class="[
                item.validation.length > 0 ? classes : '',
                item.suffix || item.prefix ? 'col' : '',
                item.ic,
              ]"
              :placeholder="
                item.decimal
                  ? '1.00'
                  : item.placeholder
                  ? item.placeholder
                  : 'Ketikkan ' + (item.label || '') + ' disini...'
              "
            />
            <template v-if="item.option.append">
              <b-input-group-append
                :class="{ [item.inputGroupClass]: true }"
                v-for="(p, i) in item.option.append"
                :key="'app-' + i"
              >
                <div class="input-group-text">
                  <i v-if="p.type === 'icon'" :class="p.name + ' p-0'"> </i>
                  <span v-if="p.type === 'text'"> {{ p.name }} </span>
                </div>
              </b-input-group-append>
            </template>
          </b-input-group>
          <div class="invalid-feedback">{{ errors[0] }}</div>
        </template>
        <template v-else-if="item.type == 'phone-number'">
            <input
              type="text"
              class="form-control"
              :disabled="disabled"
              :value="tmp_value"
              :placeholder="item.placeholder || ''"
              @input="onPhoneTextInput"
            />

            <div v-if="phoneError" class="invalid-feedback d-block">
              {{ phoneError }}
            </div>
        </template>
        <template v-else>
          <vue-numeric
            :disabled="disabled"
            v-model="tmp_value"
            separator=","
            :empty-value="item.decimal ? 0 : ''"
            :precision="item.decimal ? 2 : 0"
            :decimal-separator="'.'"
            :currency="item.type === 'money' ? 'Rp.' : null"
            v-bind="item.attr"
            v-on:input="$emit('input', tmp_value)"
            class="form-control"
            :class="[
              item.validation.length > 0 ? classes : '',
              item.suffix || item.prefix ? 'col' : '',
              item.ic,
            ]"
            :placeholder="
              item.decimal
                ? '1.00'
                : item.placeholder
                ? item.placeholder
                : 'Ketikkan ' + (item.label || '') + ' disini...'
            "
          />
        </template>
      </template>
      <!-- <input :disabled="disabled" v-else-if="numberType.includes(item.type)" v-model="tmp_value" v-bind="item.attr" v-on:change="revertNumberType(tmp_value)" v-number-input="item.type" type="text" class="form-control" :class="[ item.validation.length>0? classes : '',item.suffix || item.prefix? 'col' : '', item.ic]" :placeholder="item.placeholder ? item.placeholder : 'Ketikkan '+item.label+' disini...' " /> -->

      <!-- Input Type Date  -->
      <date-picker
        :inline="item.inline"
        v-else-if="dateType.includes(item.type)"
        :input-attr="{ autocomplete: 'off' }"
        v-model="tmp_value"
        v-on:input="$emit('input', $event)"
        :type="item.type"
        :input-class="'form-control'"
        :class="[item.validation.length > 0 ? classes : '', item.ic]"
        :placeholder="item.placeholder || null"
        :value-type="formatDate(item.type)"
        :show-second="false"
        :format="item.type === 'time' ? 'HH:mm' : 'YYYY-MM-DD'"
        :formatter="item.formatter || null"
        :disabled="disabled || item.disabled"
        :disabled-date="disabledRange"
        :range="item.type === 'daterange'|| item.type === 'date-range'? true : false"
      />

      <!-- Input Type Year -->
      <b-form-select
        :inline="item.inline"
        v-else-if="yearType.includes(item.type)"
        :input-attr="{ autocomplete: 'off' }"
        v-model="tmp_value"
        v-on:input="$emit('input', $event)"
        :type="item.type"
        :input-class="'form-control'"
        :class="[item.validation.length > 0 ? classes : '', item.ic]"
        :placeholder="item.placeholder || null"
        :value-type="formatDate(item.type)"
        :show-second="false"
        :format="item.type === 'time' ? 'HH:mm' : (item.type === 'year' ? 'YYYY' : 'YYYY-MM-DD')"
        :formatter="item.formatter || null"
        :disabled="disabled || item.disabled"
        :disabled-date="disabledRange"
      >
        <option :value="null" disabled>-- Pilih tahun --</option>
        <option v-for="option in yearOptions" :value="option">
          {{ option }}
        </option>
      </b-form-select>

      <!-- Input Type Select  -->
      <div
        v-else-if="item.type === 'select'"
        :class="{
          'd-flex flex-row align-items-center justify-content-between':
            item.createPath,
        }"
      >
        <div class="w-100">
          <v-select
            :disabled="disabled"
            label="label"
            @option:selected="onSelectOption"
            v-model="tmp_value"
            :reduce="(x) => x.code"
            :options="tmp_options"
            v-on:input="$emit('input', $event)"
            v-bind="item.attr"
            :appendToBody="item.notAppendToBody ? false : true"
            class="vs-style"
            :placeholder="item.placeholder || null"
            :class="[
              item.validation.length > 0 ? classes : item.nm ? 'mb-0' : 'mb-0',
              item.ic,
              item.classItem,
              {
                // 'vs-style-with-path': item.createPath,
                'mr-2': item.createPath,
              },
            ]"
            @search="searchDataOption"
            @open="initialDataOption"
            :error="errors"
          >
            <slot name="no-options">{{ $t("error.no_data") }}</slot>
          </v-select>
          <div class="invalid-feedback">{{ errors[0] }}</div>
        </div>
        <a
          class="btn btn-light-primary mb-0 btn-icon"
          :class="{
            'mb-5': ['select', 'lookup'].includes(item.type),
          }"
          v-if="item.createPath"
          :href="'/#/' + item.createPath + '?view=create&id&ref=direct'"
          target="_blank"
          v-b-tooltip="$t('global.add_new_option')"
        >
          <i class="ri-add-fill"></i>
        </a>
      </div>

      <!-- Input Type Radio -->
      <template v-else-if="item.type === 'radio'">
        <!-- <div
          class="d-flex flex-row align-items-center mt-3"
          :class="{
              [classes]: item.validation.length > 0,
          }"
          v-model="tmp_value"
        >
          <div
            class="radio-button d-flex flex-row align-items-center"
            v-for="(_p, i) in tmp_options"
            :key="'pay-' + i"
            @click="$emit('input', _p[item.pointer && item.pointer.code ? item.pointer.code : 'id'])"
            :class="{ selected: _p[[item.pointer && item.pointer.code ? item.pointer.code : 'id']] === tmp_value}"
          >
            <i
              v-if="_p.id !== tmp_value"
              class="ri-checkbox-blank-circle-line"
            ></i>
            <i
              v-if="_p.id === tmp_value"
              class="ri-radio-button-fill"
            ></i>
            <span class="ml-4">{{ _p[item.pointer && item.pointer.label ? item.pointer.label : 'name'] }} </span>
          </div>
                @change="$emit('selected', $event ?  tmp_options.find(x => x[item.pointer.code || 'id'] === $input) : null);"
        </div> -->
        <b-form-radio-group
          :id="item.radioId || 'input-radio' + item.label"
          v-model="tmp_value"
          :disabled="disabled || item.disabled"
          :name="item.radioId || 'input-radio-option' + item.label"
          class="default-input-radio"
          @change="onChangeRadio"
        >
          <b-form-radio
            v-for="(opt, idx) in tmp_options"
            :key="idx"
            :value="opt[item.pointer.code || 'id']"
            :disabled="disabled || item.disabled"
          >
            <span class="d-flex align-items-center">
              <i
                v-if="item.pointer.icon && opt[item.pointer.icon]"
                :class="`ri-${opt[item.pointer.icon]} mr-2`"
              ></i>
              {{ opt[item.pointer.label || 'name'] }}
            </span>
          </b-form-radio>
        </b-form-radio-group>
      </template>

      <template v-else-if="item.type === 'map'">
        <div
          ref="mapContainer"
          class="rounded-xl"
          style="height: 400px; width: 100%"
        ></div>
        <div>
          Longitude: {{ location.lng||0 }}
          <br />
          Latitude: {{ location.lat||0 }}
        </div>
      </template>
      <b-form-group
        v-else-if="item.type == 'colorType'"
        :label-for="item.field"
        :description="item.description"
      >
        <div class="d-flex align-items-center gap-2">
    <!-- Color Picker -->
        <input
          type="color"
          class="form-control form-control-color flex-shrink-0"
          v-model="tmp_value"
          :id="item.field"
          :name="item.field"
          :disabled="disabled || item.disabled"
          style="width: 60px; height: 40px; cursor: pointer;"
        />

        <!-- Manual Hex Input -->
        <input
          type="text"
          class="form-control"
          v-model="tmp_value"
          placeholder="#000000"
          :disabled="disabled || item.disabled"
          style="font-family: monospace; text-transform: uppercase;"
        />
      </div>

      <!-- Show the color preview / text below -->
        <div
          class="mt-2 text-center fw-bold"
          :style="{ color: tmp_value, fontFamily: 'monospace' }"
        >
          {{ tmp_value }}
        </div>
      </b-form-group>
      <!-- Input Type Textarea  -->
      <textarea
        :disabled="disabled"
        v-else-if="item.type === 'textarea'"
        v-bind:value="value"
        v-on:input="$emit('input', $event.target.value)"
        :input-attr="{ autocomplete: 'off' }"
        class="form-control"
        :class="item.validation.length > 0 ? classes : ''"
        :placeholder="item.placeholder || null"
        :rows="item.rows || 5"
      ></textarea>
      <!-- Input Type File  -->
      <div v-else-if="item.type === 'file'" class="d-flex align-items-center">
        <div v-if="item.hasOwnProperty('option') && item.option.multiple">
          <multi-upload
            v-on="item.event"
            :error="errors"
            :classes="item.validation.length === 0 ? {} : classes"
            :placeholder="item.placeholder"
            :attr="item.attr"
            v-model="tmp_value"
            @input="$emit('input', $event)"
          />
        </div>
        <div v-else>
          <single-upload
            v-on="item.event"
            :hideLabel="item.option && item.option.hideLabel"
            :hideDesc="item.option && item.option.hideDesc"
            :isButton="item.option && item.option.isButton"
            :disabled="item.option && item.option.disabled"
            v-model="tmp_value"
            :error="errors"
            :classes="item.validation.length === 0 ? {} : classes"
            :placeholder="item.placeholder"
            :attr="item.attr"
            @input="$emit('input', $event)"
            @onError="$emit('onError', $event)"
            @before-upload="onBeforeUpload"
          />
        </div>
      </div>
      <div
        v-else-if="item.type === 'attachment'"
        class="img-form-wrapper w-100 pb-2"
        style="overflow-x: scroll"
      >
        <div
          v-for="(_att, i) in tmp_value"
          :key="'img-att' + i"
          class="d-flex flex-column mx-2"
        >
          <div class="input-img mr-3">
            <b-button
              @click="deleteAttachment(_att)"
              variant="danger-light"
              class="delete-img"
              v-if="
                ($_sys.isAllowed('delete-' + item.permissionTask) &&
                  _att.id &&
                  Array.isArray(tmp_value) &&
                  tmp_value.length > 0) ||
                (!item.permissionTask &&
                  Array.isArray(tmp_value) &&
                  tmp_value.length > 0)
              "
            >
              x
            </b-button>
            <label>
              <a>
                <img alt="" :src="_att.preview" />
                <!-- <input type="file" hidden v-bind="attributes" @change="handleFile($event)" /> -->
              </a>
            </label>
          </div>
          <v-select
            label="label"
            v-model="_att[_att.keys.category]"
            :reduce="(x) => x.code"
            :options="_att.options"
            :appendToBody="item.notAppendToBody ? false : true"
            class="vs-style v-select-40 mt-2"
            :placeholder="item.placeholder || 'UNCATEGORIZED'"
            :class="[
              item.validation.length > 0 ? classes : item.nm ? 'mb-0' : 'mb-0',
              item.ic,
              item.classItem,
            ]"
            :disabled="
              item.disabled ||
              (item.api === 'production-unit' &&
                $store.state.profile.corporate_level === false) ||
              !$_sys.isAllowed('update-' + item.permissionTask)
            "
            @search="(search, loading) => searchAttachment(search, loading, i)"
            @open="searchAttachment('', null, i)"
          >
            <slot name="no-options">{{ $t("error.no_data") }}</slot>
          </v-select>
        </div>
        <single-upload
          v-on="item.event"
          :hideLabel="item.option && item.option.hideLabel"
          :hideDesc="true"
          :isButton="item.option && item.option.isButton"
          :error="errors"
          :classes="item.validation.length === 0 ? {} : classes"
          :placeholder="item.placeholder"
          :attr="item.attr ? item.attr : [{ limit: 5 }]"
          :grid="true"
          @input="onUpload($event)"
          @onError="$emit('onError', $event)"
          v-if="
            $_sys.isAllowed('create-' + item.permissionTask) ||
            !item.permissionTask
          "
          @before-upload="onBeforeUpload"
        />
      </div>
      <!-- Input Type Map  -->
      <div v-else-if="item.type === 'map'">
        <g-maps
          :classes="item.validation.length > 0 ? classes : {}"
          :errors="errors"
          @inputChange="updateCoordinates($event)"
          :zoomNum="10"
          :type="'input'"
          :placeholder="item.placeholder"
          :sendData="{
            formatted_address: item.option.formated_address,
            lat: item.option.lat,
            lng: item.option.lng,
          }"
        >
          <div class="invalid-feedback">{{ errors[0] }}</div>
          <template v-slot:lookup-location-form>
            <slot name="lookup-location-form" />
          </template>
        </g-maps>
        <!-- <div style="height: 45px"></div> -->
      </div>
      <!-- Input Type Lookup  -->
      <lookup-input
        v-else
        :class="item.classItem"
        :title="item.label"
        :defaultCaption="item.defaultCaption"
        v-model="tmp_value"
        v-on:input="$emit('input', $event)"
        :endpoint="item.api"
        :pointer="item.pointer"
        :param="item.param"
        :isObject="item.isObject"
        :placeholder="item.placeholder || null"
        :classes="item.validation.length > 0 ? classes : {}"
        :errors="errors"
        :multiple="false"
        :disabled="item.disabled || false"
        :wrapperClass="item.wrapperClass || ''"
      />
      <label class="col-auto col-form-label" v-if="item.suffix">
        {{ item.suffix }}
      </label>
      <div class="invalid-feedback">{{ errors[0] }}</div>
    </ValidationProvider>
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import _config from "@/config.js";
export default {
  name: "minimalize-input",
  props: {
    setData: { required: false, default: () => ({}) },
    item: { type: Object, required: true, default: () => ({}) },
    value: { required: false },
    disabled: { required: false, default: () => false },
  },
  data() {
    return {
      selectedOptionsCache: [],
      defaultType: [
        "text",
        "email",
        "hidden",
        "password",
        "tel",
        "url",
        "color",
      ],
      dateType: ["date", "datetime", "month", "time", "week", "daterange"],
      yearType: ["year"],
      mapType: ["map"],
      numberType: ["number", "money", "phone-number"],
      yearOptions: _config.options.yearOptions,
      vSelectOption: null,
      tmp_value: null,
      tmp_option: [],
      tmp_options: [],
      uploadLimitExceed: false,
      map: null,

      // number
      phoneError: null,

      // fake
      location: {},
      coords: {
        lat: -7.031947468915877,
        lng: 110.49704882054397,
      },
      markers: null,
    };
  },
  watch: {
    value: {
      immediate: true,
        handler(to, from) {
          if (
            this.item.type === 'select' &&
            this.item.attr &&
            this.item.attr.multiple &&
            Array.isArray(to)
          ) {
            const cached = this.selectedOptionsCache || []

            this.selectedOptionsCache = cached.filter(opt =>
              to.includes(opt.code)
            )

            this.tmp_options.forEach(opt => {
              if (
                to.includes(opt.code) &&
                !this.selectedOptionsCache.some(x => x.code === opt.code)
              ) {
                this.selectedOptionsCache.push(opt)
              }
            })
            this.tmp_options = [
              ...this.selectedOptionsCache,
              ...this.tmp_options.filter(
                o => !this.selectedOptionsCache.some(c => c.code === o.code)
              )
            ]
          }

          if (this.item.type !== "select") {
            if (!this.defaultType.includes(this.item.type)) {
              this.tmp_value = to
            }
          } else {
            this.tmp_value = to
            if (!to) {
              this.vSelectOption = null
            }
            if (
              this.item.api === "production-unit" &&
              this.$store.state.profile.corporate_level === true
            ) {
              this.$store.commit("set", ["temporary_up_id", to, true])
            }
          }
      },
    },

    tmp_value: {
      handler(to) {
        if (this.item.type === "radio") {
          this.$emit("input", to)
        }
      },
    },

    "item.param": {
      deep: true,
      handler(to, from) {
        if (JSON.stringify(from) !== JSON.stringify(to) && this.item.autoFill) {
          this.checkAutoFillData()
        }
      },
    },
    'item.options': {
      deep: true,
      handler(newVal) {
        if (this.item.type === 'select' && Array.isArray(newVal)) {
          this.tmp_options = newVal;
        }
      }
    },
  },
  mounted() {
    if (this.item.type === "radio") {
      if (Array.isArray(this.item.options)) {
        this.tmp_options = this.item.options;
      } else {
        this.initialDataOption();
      }
      this.tmp_value = this.value;
    }
    if (
      !this.defaultType.includes(this.item.type) &&
      ["select", "attachment"].includes(this.item.type)
    ) {
      this.tmp_value = this.value;
    }

    if (this.item.type === "attachment") {
      this.tmp_value = [];
    }
    if (this.item.type === "select") {
      if (this.item.autoFill) {
        this.checkAutoFillData();
      }
      if (this.item.options && !this.item.autoFill) {
        this.tmp_options = this.item.options;
      }
      if (this.item.defaultOptions) {
        const defaults = this.prepareDefaultOptions()
        this.tmp_options = defaults;
        if (this.item.attr && this.item.attr.multiple && Array.isArray(this.value)) {
          this.selectedOptionsCache = defaults.filter(function(opt) {
          return this.value.includes(opt.code);
          }, this);
        }
      }
      if (this.item.defaultCaption) {
        this.vSelectOption = {
          code: this.value,
          label: this.item.defaultCaption,
        };
        this.tmp_options = [
          { code: this.value, label: this.item.defaultCaption },
        ];
      } else {
        this.$watch("item.defaultCaption", (to) => {
          if (to) {
            this.vSelectOption = { code: this.value, label: to };
            this.tmp_options = [{ code: this.value, label: to }];
          }
        });
      }
    }

    if (this.item.type === "file") {
      if (this.item.hasOwnProperty("option") && this.item.option.multiple) {     
        this.tmp_value = this.value || [];
      } else {
        this.tmp_value = this.value || {};
      }
    }

    if (this.item.type === "map") {
      this.initMap();
    }
  },
  methods: {
    prepareDefaultOptions() {
      if (!this.item.defaultOptions || !this.item.defaultOptions.data || this.item.defaultOptions.data.length === 0) {
        return []
      }
      return this.item.defaultOptions.data.map(item => ({
        code: this.getNestedValue(
          item,
          this.item.defaultOptions.code
        ),
        label: this.getNestedValue(
          item,
          this.item.defaultOptions.label
        )
      }))
    },
    onSelectOption(option) {
      if (!option) return

      this.vSelectOption = option
      // multiple
      if (this.item.attr && this.item.attr.multiple) {
        const exists = this.selectedOptionsCache.find(
          x => x.code === option.code
        )
        if (!exists) {
          this.selectedOptionsCache.push(option)
        }
      } else {
        this.selectedOptionsCache = [option]
      }

      this.$emit('selected', option)
      this.$emit('change', option)
    },
    onBeforeUpload(file) {
      this.$emit('before-upload', file)
    },
    async initMap() {
      this.map = new mapboxgl.Map({
        accessToken: this.$_config.apikey.mapbox,
        container: this.$refs.mapContainer,
        style: "mapbox://styles/mapbox/satellite-streets-v12",
        center: [this.coords.lng, this.coords.lat],
        zoom: 9,
      });

      this.markers = await new mapboxgl.Marker({
        draggable: true,
      })
        .setLngLat({
          lat: this.coords.lat,
          lng: this.coords.lng,
        })
        .addTo(this.map);

      await this.map.on("load", async function () {});
      this.map.resize();

      await this.map.addControl(new mapboxgl.FullscreenControl());
      await this.map.addControl(new mapboxgl.NavigationControl());
      const geolocate = new mapboxgl.GeolocateControl({
        positionOptions: {
          enableHighAccuracy: true,
        },
        trackUserLocation: true,
        showUserHeading: true,
      });
      await this.map.addControl(geolocate);
      this.map.on("click", async (e) => {
        await this.markers.setLngLat(e.lngLat);
        this.location = e.lngLat;
        const coordinates = JSON.parse(JSON.stringify(e.lngLat));
        this.$emit("input", coordinates);
      });
    },

    onChangeRadio(e) {
      // console.log('e', e)
      this.$emit(
        "selected",
        e
          ? this.tmp_options.find(
              (x) => x[this.item.pointer.code || "id"] === e
            )
          : null
      );
    },
    disabledRange(date) {
      // console.log(date)
      if (!this.item.min && !this.item.max) {
        return false;
      } else if (this.item.min && !this.item.max) {
        var minDate =
          this.item.min === "today"
            ? moment()
            : moment(this.item.min, "YYYY-MM-DD");
        return moment(date).diff(minDate, "days") < 0;
      } else if (!this.item.min && this.item.max) {
        var maxDate =
          this.item.max === "today"
            ? moment()
            : moment(this.item.max, "YYYY-MM-DD");

        return (
          moment(date).diff(maxDate, "days") >= 0 &&
          moment(date).format("YYYY-MM-DD") !== moment().format("YYYY-MM-DD")
        );
      } else if (this.item.min && this.item.max) {
        var minDate =
          this.item.min === "today"
            ? moment()
            : moment(this.item.min, "YYYY-MM-DD");
        var maxDate =
          this.item.max === "today"
            ? moment()
            : moment(this.item.max, "YYYY-MM-DD");
        return (
          moment(date).diff(minDate, "days") < 0 ||
          (moment(date).diff(maxDate, "days") >= 0 &&
            moment(date).format("YYYY-MM-DD") !== moment().format("YYYY-MM-DD"))
        );
      }
    },
    deleteAttachment(data) {
      const docId = data.id;

      if (this.item.deleteEndpoint) {
        this.$_alert
          .confirm(
            "Hapus Dokumen",
            "Apakah anda yakin ingin menghapus dokumen?",
            "Ya, Hapus",
            "Batal",
            true
          )
          .then((resp) => {
            if (resp.isConfirmed) {
              let endPoint = this.item.deleteEndpoint.replace(":id", docId);

              this.$_api
                .delete(endPoint, data)
                .then((response) => {
                  let idx = this.value.findIndex((item) => item.id === docId);

                  if (idx > -1) {
                    this.value.splice(idx, 1);

                    this.$emit("input", this.value);
                    this.$_alert.success("Attachment berhasil dihapus");
                  }
                })
                .catch((err) => {
                  this.$_alert.error(err);
                });
            }
          });
      } else {
        let idx = this.value.findIndex((item) => item.id === docId);

        if (idx > -1) {
          this.value.splice(idx, 1);

          this.$emit("input", this.value);
        }
      }
    },
    searchAttachment(search, loading, index) {
      if (loading instanceof Function) loading(true);
      this.$_api
        .get(`/lookup/${this.item.api}`, { search: search })
        .then((response) => {
          let _opt = [];
          for (const item of response.data) {
            _opt.push({
              label: item.name,
              code: item.id,
              value: item.id,
            });
          }
          this.tmp_value[index].options = _opt;

          if (loading instanceof Function) loading(false);
        })
        .catch(() => {
          if (loading instanceof Function) loading(false);
        });
    },
    onUpload(e) {
      const keyCategory = this.item.option.key_select || "document_category_id";
      const keyCategoryLabel =
        this.item.option.key_select_label || "document_category_name";
      const keyName = this.item.option.key_name || "name";
      const keyAttachment = this.item.option.key_attachment || "attachment";

      const attachmentModel = {
        [keyCategory]: null,
        [keyName]: e.file,
        [keyAttachment]: e.file,
        [keyCategoryLabel]: "",
        preview: e.preview,
        keys: {
          category: keyCategory,
          name: keyName,
          attachment: keyAttachment,
        },
        options: [],
      };

      this.tmp_value.push(attachmentModel);
      this.$emit("input", this.tmp_value);
    },
    vSelected(e) {
      this.vSelectOption = null;
      if (e) this.vSelectOption = e;
    },
    formatDate(type) {
      let _format;
      switch (type) {
        case "date":
        case "date-range":
        case "daterange":
          _format = "YYYY-MM-DD";
          break;
        case "datetime":
        case "datetime-range":
          _format = "YYYY-MM-DD HH:mm:ss";
          break;
        case "year":
        case "year-range":
          _format = "YYYY-MM-DD";
          break;
        case "month":
        case "month-range":
          _format = "YYYY-MM-DD";
          break;
        case "time":
          _format = "HH:mm";
          break;
        case "time-range":
          _format = "HH:mm:ss";
          break;
        case "week":
        case "week-range":
          _format = "DD";
          break;
      }
      return _format;
    },

    checkAutoFillData() {
      if (!Array.isArray(this.item.options)) {
        this.$_api
          .dataset(this.item.api, this.item.param ? this.item.param : {})
          .then((res) => {
            let _data = [];

            for (const _value of res.data) {
              let _val = _value;
              _val.label = _value[this.item.pointer.label];
              _val.code = _value[this.item.pointer.code];
              const codeVal = this.getNestedValue(_value, this.item.pointer.code);
              if (this.value !== codeVal) {
                _data.push(_val);
              }
            }

            if (res.data.record === 1) {
              this.tmp_value = res.data[0].code;
              this.$emit("input", this.tmp_value);
              this.vSelectOption = {
                code: res.data[0].code,
                label: res.data[0][this.item.pointer.label],
              };

              this.tmp_options = [
                {
                  code: res.data[0].code,
                  label: res.data[0][this.item.pointer.label],
                },
              ];
            } else {
              this.tmp_options = _data;
            }
          })
          .catch((err) => {
            this.$_alert.error(err);
          });
      }

      if (Array.isArray(this.item.options)) {
        if (this.item.options.length === 1) {
          this.tmp_value =
            this.item.options[0][this.item.pointer.code] ||
            this.item.options[0].code;
          this.$emit("input", this.tmp_value);
          this.vSelectOption = {
            code:
              this.item.options[0][this.item.pointer.code] ||
              this.item.options[0].code,
            label: this.item.options[0][this.item.pointer.label],
          };

          this.tmp_options = [
            {
              code:
                this.item.options[0][this.item.pointer.code] ||
                this.item.options[0].code,
              label: this.item.options[0][this.item.pointer.label],
            },
          ];
        } else {
          let _tmp_option = [];
          for (const _opt of this.item.options) {
            _tmp_option.push({
              code: _opt[this.item.pointer.code] || _opt.code,
              label: _opt[this.item.pointer.label],
            });
          }
          this.tmp_options = _tmp_option;
        }
      }
    },

    initialDataOption() {
      if (Array.isArray(this.item.options)) return;
      if (!this.item.api) return;
      let params = {
        ...this.item.param,
        limit: 10,
      };

      if (["uom", "/uom"].includes(this.item.api)) {
        params.limit = 500;
      }

      this.$_api
        .dataset(this.item.api, params)
        .then((res) => {
          let _data = [];
          // if (this.vSelectOption && !_data.some(opt => opt.code === this.vSelectOption.code)) {
          //   _data.push(this.vSelectOption);
          // }

          for (const _value of res.data) {
            var labelArr = [];
            var labelSeparator = this.item.pointer.separator
              ? this.item.pointer.separator
              : " - ";
            var labels = Array.isArray(this.item.pointer.display)
              ? this.item.pointer.display
              : [this.item.pointer.label];

            for (const labelKey of labels) {
              const val = this.getNestedValue(_value, labelKey);
              if (val) {
                labelArr.push(val);
              }
            }
            let _val = _value;
            _val.label = labelArr.join(labelSeparator);

            _val.code = this.getNestedValue(_value, this.item.pointer.code);
            if (this.item.pointer.displayFormat) {
              _val.label = this.item.pointer.displayFormat;

              for (let _i = 0; _i < labelArr.length; _i++) {
                _val.label = _val.label.replace(
                  new RegExp(`\\%${_i}%`, "gm"),
                  labelArr[_i]
                );
              }
            }
            const codeVal = this.getNestedValue(_value, this.item.pointer.code);
            if (this.value !== codeVal) {
              _data.push(_val);
            }
          }
          if (this.item.attr && this.item.attr.multiple) {
            this.tmp_options = this.mergeOptionsWithCache(_data)
          } else {
            if (
              this.value &&
              this.vSelectOption &&
              !_data.some(x => x.code === this.value)
            ) {
              _data.unshift(this.vSelectOption)
            }
            this.tmp_options = _data
          }
        })
        .catch((err) => {
          this.$_alert.error(err);
        });
    },
    searchDataOption: _.debounce(function (search, loading, limit = 10) {
      if (Array.isArray(this.item.options)) return;
      if (!this.item.api) return;
      if (!search) return;
      if (loading instanceof Function) loading(true);
      let params = {
        search: search,
        ...this.item.param,
        limit: limit,
      };

      this.$_api
        .dataset(this.item.api, params)
        .then((res) => {
          if (loading instanceof Function) loading(false);
          let _data = []
          if (this.item.attr && this.item.attr.multiple) {
            this.selectedOptionsCache.forEach(opt => {
              if (!_data.some(x => x.code === opt.code)) {
                _data.push(opt)
              }
            })
          }
          if ((!this.item.attr || !this.item.attr.multiple) && this.vSelectOption) 
          {
            _data.push(this.vSelectOption)
          }
          for (const _value of res.data) {
            var labelArr = [];
            var labelSeparator = this.item.pointer.separator
              ? this.item.pointer.separator
              : " - ";
            var labels = Array.isArray(this.item.pointer.display)
              ? this.item.pointer.display
              : [this.item.pointer.label];


            for (const labelKey of labels) {
              const val = this.getNestedValue(_value, labelKey);
              if (val) {
                labelArr.push(val);
              }
            }
            let _val = _value;
            _val.code = this.getNestedValue(_value, this.item.pointer.code);
            _val.label = labelArr.join(labelSeparator);

            if (this.item.pointer.displayFormat) {
              _val.label = this.item.pointer.displayFormat;
              for (let i = 0; i < labelArr.length; i++) {
                _val.label = _val.label.replace(
                  new RegExp(`\\%${i}%`, "gm"),
                  labelArr[i]
                );
              }
            }

            if (this.value !== _val.code) {
              _data.push(_val);
            }
          }
            // for (const _value of res.data) {
            //   let _val = _value;
            //   _val.label = _value[this.item.pointer.label];
            //   _val.code = _value[this.item.pointer.code];
            //   if (this.value !== _value[this.item.pointer.code]) {
            //     _data.push(_val);
            //   }
            // }
          if (
            this.value &&
            this.vSelectOption &&
            !_data.some(x => x.code === this.value)
          ) {
            _data.unshift(this.vSelectOption)
          }
          this.tmp_options = _data;
        })
        .catch((err) => {
          if (loading instanceof Function) loading(false);
          this.$_alert.error(err);
        });
    }, 600),
    getNestedValue(obj, path) {
      try {
        return path
          .replace(/\[(\w+)\]/g, '.$1') // turn [0] into .0
          .split('.')
          .reduce(function (o, k) {
            if (o && typeof o === 'object' && k in o) {
              return o[k];
            }
            return null;
          }, obj);
      } catch (e) {
        return null;
      }
    },
    mergeOptionsWithCache(options = []) {
      return [
        ...this.selectedOptionsCache,
        ...options.filter(
          o => !this.selectedOptionsCache.some(c => c.code === o.code)
        )
      ]
    },
    getDataOption(api, pointer) {
      let filter = {
        limit: 2,
      };
      if (this.item.param) filter = { ...filter, ...this.item.param };
      this.$_api.dataset(api, filter).then((res) => {
        this.tmp_option = res.data.map(function (x) {
          return { label: x[pointer.label], code: x[pointer.code] };
        });
      });
    },
    handleFile(e) {
      let limit = this.item.limit || 5;
      if ((e.target.files[0].size / 1000000).toFixed(2) < limit) {
        this.uploadLimitExceed = false;
        let file = e.target.files[0];
        var reader = new FileReader();
        reader.readAsDataURL(file);
        this.$_api
          .fileUpload(file, (event) => {
            this.tmp_value = file;
            this.uploadPercentage = Math.round(
              (100 * event.loaded) / event.total
            );
          })
          .then((res) => {
            this.$emit("input", res.data.file);
            e.target.value = null;
          })
          .catch((err) => {
            this.$emit("input", null);
            e.target.value = null;
          });
      } else this.uploadLimitExceed = true;
    },
    revertNumberType(value) {
      const numberPattern = /\d+/g;
      if (value) {
        this.$emit(
          "input",
          Number(value[0].toString().match(numberPattern).join(""))
        );
      } else this.$emit("input", 0);
    },
    updateCoordinates(location) {
      this.$emit("onChange", location);
    },
    onPhoneTextInput(e) {
      let val = e.target.value;

      val = val.replace(/\D/g, '');

      this.tmp_value = val;

      if (!val) {
        this.phoneError = null;
        this.$emit('input', null);
        return;
      }

      if (val.length < 9 || val.length > 13) {
        this.phoneError = 'Nomor telepon harus 9-13 digit';
        this.$emit('input', val);
        return;
      }

      this.phoneError = null;
      this.$emit('input', val);
    }
  },
};
</script>

<style scoped>
.delete-img {
  width: 30px;
  height: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0;
  margin: 0;
  font-weight: bold;
  position: absolute;
  right: 10px;
  top: 10px;
}

.input-number-default {
  height: 38px;
}

.input-number-default input {
  height: 38px;
}

.input-number-default {
  height: 38px;
}

.vs-style.no-border {
  border: none !important;
}

/* .mx-datepicker { */
/* display: block !important; */
/* } */
</style>



// WEBPACK FOOTER //
// src/base/component/single-input.vue